    <!-- Action Buttons -->
<div class="bottom-actions" style="border-bottom: 1px solid #a9a9a9a8;">

  <!-- ========== STATE: draft + role: author ========== -->
  <ng-container *ngIf="pssState === 'Draft' && role === 'author' && !isPreview">
    <app-common-button
      label="Save"
       title="Save"
        [critical]="false"
      [buttonId]="1111"
      (clicked)="SaveJSon()">
      Save
    </app-common-button>

    <app-common-button
      label="Submit"
       title="Submit"
       [buttonId]="1111"
      [critical]="false"
      (clicked)="onSubmit()">
    </app-common-button>
  </ng-container>


  <!-- ========== STATE: inReview + role: author ========== -->
  <ng-container *ngIf="pssState === 'In Review' && role === 'author' && !isPreview">
    <app-common-button
      label="Update"
       title="Update"
        [critical]="true"
	     [buttonId]="113"
      
      (clicked)="Update()">
      Update
    </app-common-button>
  </ng-container>


  <!-- ========== STATE: inReview + role: reviewer ========== -->
  <ng-container *ngIf="pssState === 'In Review' && role === 'reviewer' && !isPreview">
    <app-common-button
      label="Review"
       title="Review"
       [critical]="true"
	     [buttonId]="125"
      
      (clicked)="onComplete()">
      
    </app-common-button>
  </ng-container>


  <!-- ========== STATE: inApproval + role: approver ========== -->
   <!-- Change the below role to approver after creating roles pass from parent component  -->
  <ng-container *ngIf="pssState === 'In Approval' && role === 'reviewer' && !isPreview">
    <!-- <button
      class="download-btn btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
      style="padding:4px 14px; font-size:13px; min-width:80px; height:34px;"
      (click)="onApprove()">
      Approve
    </button> -->

      <app-common-button
      
      
	   label="Approve"
       title="Approve"
     
	   [critical]="true"
	  [buttonId]="103"
      (clicked) ="onApprove()">
    </app-common-button>

    <app-common-button
      label="Reject"
       title="Reject"
      
      [critical]="false"
      [buttonId]="1111"
      (clicked)="onReject()">
    </app-common-button>
  </ng-container>


  <!-- ========== COMMON CANCEL (shown for all states/roles/preview) ========== -->
  <app-common-button
    type="button"
    label="{{ role === 'author' ? 'Cancel' : 'Close' }}"
    title="{{ role === 'author' ? 'Cancel' : 'Close' }}"
    [critical]="false"
    [buttonId]="1111"
   
    (clicked)="onCancel()">
    {{ role === 'author' ? 'Cancel' : 'Close' }}
  </app-common-button>

</div>

<div class="preview-wrapper" *ngIf="json">

  <!-- Sidebar -->
  <div class="left-sidebar">
    <h4>Sections</h4>
    <ul >
        <li
          *ngFor="let section of json.sections; let si = index"
          (click)="scrollToSection(si)"
          [class.active]="selectedSectionIndex === si"
            >
          
          <span class="title-with-badge" style="  overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;"
            [matTooltip]="section['Section Title']"
            matTooltipPosition="right">
            {{ section['Section Title'] }}
          </span>

          <span *ngIf="getCommentCount(si, section) > 0" class="comment-count">
            {{ getCommentCount(si, section) }}
          </span>
        </li>

    </ul>
  </div>

  <!-- Main Container -->
  <div class="preview-container" id="preview-container" #previewContainer>
    <h3 class="title">
      Product Safety Strategy <span>{{ json['Product Name'] }}</span>
    </h3>

    <!-- Meta Info
    <div class="meta">
      <p><strong>Product Name:</strong> {{ json['Product Name'] }}</p>
    </div> -->

    <!-- Sections -->
    <div
      *ngFor="let section of json.sections; let si = index"
      class="section"
      [id]="'section-' + si"
      [class.active-section]="selectedSectionIndex === si">

      <!-- Section Title -->
      <h3 class="section-title" [matTooltip]="section['Section Title']" matTooltipPosition="right">{{ section['Section Title'] }}</h3>

      <!-- Key-Value Sections -->
      <div *ngIf="section['Section Type'] === 'key-value'">
        <div
          *ngFor="let row of getSectionArray(section); let i = index; trackBy: trackByIndex"
          class="kv-row flex gap-2 items-center">

          <!-- Key (always readonly) -->
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [(ngModel)]="row.Column1"
              placeholder="Key"
              [readonly]="true" />
          </mat-form-field>

          <!-- Value (editable only for author) -->
          <mat-form-field appearance="outline" class="flex-1">
            <input
              matInput
              [(ngModel)]="row.Column2"
              placeholder="Value"
              [readonly]="role !== 'author'"
              (focus)="isEditing = true"
              (blur)="isEditing = false" 
              />
          </mat-form-field>
        </div>
      </div>

      <!-- Text Sections -->
      <div *ngIf="section['Section Type'] === 'text'">
        <mat-form-field appearance="outline" class="full-width">
          <textarea
            matInput
            [value]="getSectionArray(section).join('\n')"
            (input)="updateTextSection($event, section)"
            [readonly]="role !== 'author'"
            rows="4"
            (focus)="isEditing = true"
            (blur)="isEditing = false"
           >
          </textarea>
        </mat-form-field>
      </div>

       <!-- Table Sections -->
      <div *ngIf="section['Section Type'] === 'table'" class="table-container">
        <div class="scrollable-table">
          <table>
            <thead>
              <tr>
                <th *ngFor="let key of getTableHeaders(section)">{{ key }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of getSectionArray(section); let ri = index; trackBy: trackByIndex">
                <td *ngFor="let key of getTableHeaders(section)">
                  <mat-form-field appearance="outline" class="table-input">
                  <!-- multiline: use textarea when newline present -->
                  <ng-container *ngIf="isMultiline(row[key]); else singleLineInput">
                    <textarea
                      matInput
                      [(ngModel)]="row[key]"
                      placeholder="{{ key }}"
                      [readonly]="role !== 'author'"
                      class="auto-textarea"
                      #autoArea
                      (input)="autoResize(autoArea)"
                      (ngModelChange)="autoResize(autoArea)"
                      (focus)="isEditing = true"
                      (blur)="isEditing = false"
                    ></textarea>
                  </ng-container>




    <!-- single-line input with ellipsis + tooltip when truncated -->
    <ng-template #singleLineInput>
      <input
        matInput
        class="single-line-input"
        [(ngModel)]="row[key]"
        placeholder="{{ key }}"
        [readonly]="role !== 'author'"
        (focus)="isEditing = true"
        (blur)="isEditing = false"
        [matTooltip]="isTruncated(row[key], truncateLimit) ? getTooltipText(row[key]) : null"
        matTooltipPosition="above"
      />
    </ng-template>
  </mat-form-field>
</td>


              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Fallback -->
      <div *ngIf="!['key-value','text','table'].includes(section['Section Type'])">
        <pre>{{ getSectionArray(section) | json }}</pre>
      </div>
    </div>
  </div>

</div>


